import type { InvoiceConfig } from "@/interfaces/invoiceConfig";

/**
 * Invoice configuration for Trans4m club.
 * Filename matches club slug: trans4m
 */
export const trans4mInvoiceConfig: InvoiceConfig = {
  title: "FACTURE",
  headerText: "Trans4m - Performance & Fitness",
  footerText: "Merci pour votre confiance.",
  address: "10 Rue des Sports, Casablanca",
  contact: {
    phone: "+212 5 22 11 22 33",
    email: "contact@trans4m.ma",
  },
  signatureLabel: "Signature",
  forClubLabel: "Pour Trans4m",
};
